import { render, staticRenderFns } from "./OptionNode.vue?vue&type=template&id=2ede7c36&scoped=true&"
import script from "./OptionNode.vue?vue&type=script&lang=js&"
export * from "./OptionNode.vue?vue&type=script&lang=js&"
import style0 from "./OptionNode.vue?vue&type=style&index=0&id=2ede7c36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ede7c36",
  null
  
)

export default component.exports